module.exports = __webpack_public_path__ + "img/home-default-2.019d529.png";